import { render, staticRenderFns } from "./td-Email.vue?vue&type=template&id=ab39ac74&"
import script from "./td-Email.vue?vue&type=script&lang=js&"
export * from "./td-Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ab39ac74', component.options)
    } else {
      api.reload('ab39ac74', component.options)
    }
    module.hot.accept("./td-Email.vue?vue&type=template&id=ab39ac74&", function () {
      api.rerender('ab39ac74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/comps/td-Email.vue"
export default component.exports